import api from '@/api'

export const getDomain = (url = window.location.hostname, subdomain = false) => {
  url = url.replace(/(https?:\/\/)?(www.)?/i, '')
  if (!subdomain) {
    url = url.split('.')
    url = url.slice(url.length - 2).join('.')
  }
  if (url.indexOf('/') !== -1) {
    return url.split('/')[0]
  }
  return url
}

export const signup = async (payload) => {
  const urlEnd = '/v2/users/signup'
  const type = 'post'
  const resp = await api.asyncRequest(urlEnd, type, payload)
  if (resp.ok === false) return Promise.reject(resp.data)
  const { sessionToken, objectId } = resp.data
  setupApiToken({ sessionToken, userId: objectId, loginType: 'istaging' })
  try {
    localStorage.setItem(`session-token-${process.env.NODE_ENV}`, sessionToken)
  } catch (error) {}
  return resp.data
}

export const checkUserExist = async (email) => {
  const urlEnd = `/v2/users/exist?email=${email}`
  const type = 'get'
  const resp = await api.asyncRequest(urlEnd, type)
  if (resp.ok) return resp.data
  else return Promise.reject(resp.data)
}

export const login = async (loginInfo, isKeepLogin) => {
  const urlEnd = '/v1/users/login'
  const type = 'post'
  const body = Object.assign({}, loginInfo, { allowVisitor: true })
  const resp = await api.asyncRequest(urlEnd, type, body)
  if (resp.ok === false) return Promise.reject(resp.data)
  const { sessionToken, objectId } = resp.data
  setupApiToken({ sessionToken, userId: objectId, loginType: 'istaging' })
  if (isKeepLogin) {
    try {
      localStorage.setItem(`session-token-${process.env.NODE_ENV}`, sessionToken)
    } catch (error) {}
  }
  return resp.data
}

export const sessionLogin = async (sessionToken = '') => {
  const urlEnd = `/v1/users/login/${sessionToken}`
  const type = 'post'
  const resp = await api.asyncRequest(urlEnd, type)
  if (resp.ok === false) return Promise.reject(resp.data)
  setupApiToken({ sessionToken: resp.data.sessionToken, userId: resp.data.objectId, loginType: 'istaging' })
  try {
    localStorage.setItem(`session-token-${process.env.NODE_ENV}`, resp.data.sessionToken)
  } catch (error) {}
  return resp.data
}

export const updateProfile = async (userId, payload = {}) => {
  const urlEnd = `/v2/users/profile/${userId}`
  const type = 'put'
  const resp = await api.asyncRequest(urlEnd, type, payload)
  if (resp.ok) return resp.data
  return Promise.reject(resp.data)
}

// payload = {username: email, oldPassword, newPassword}
export const changePassword = async (payload) => {
  const urlEnd = '/v1/users/password/change'
  const type = 'post'
  const resp = await api.asyncRequest(urlEnd, type, payload)
  if (resp.ok) return resp.data
  return Promise.reject(resp.data.error)
}

export const logout = async () => {
  const urlEnd = '/v1/users/logout'
  const type = 'post'
  const resp = await api.asyncRequest(urlEnd, type)
  if (resp.ok === false) return Promise.reject(resp.data)
  removeApiToken()
}

export const getUserProfile = async () => {
  const token = localStorage.getItem(`session-token-${process.env.NODE_ENV}`)
  api.sendHeaders('iStaging-Token', token)
  const urlEnd = '/v2/users/profile'
  const type = 'get'
  const resp = await api.asyncRequest(urlEnd, type)
  if (resp.ok) {
    const { sessionToken, objectId } = resp.data
    setupApiToken({ sessionToken, userId: objectId, loginType: 'istaging' })
    return resp.data
  } else {
    api.removeHeaders('iStaging-Token')
    return Promise.reject(resp.data)
  }
}

const setupApiToken = ({ userId, sessionToken, loginType }) => {
  api.sendHeaders('iStaging-Token-Type', loginType)
  api.sendHeaders('iStaging-Token', sessionToken)
  api.sendHeaders('istaging-user-id', userId)
}

const removeApiToken = () => {
  api.removeHeaders('iStaging-Token-Type')
  api.removeHeaders('iStaging-Token')
  api.removeHeaders('istaging-user-id')
}
